import { Skeleton } from '@/shared/ui/Skeleton';
import skeletonStyles from './AppShellSkeleton.module.css';

export function AppShellSkeleton() {
  return (
    <div className={skeletonStyles.shellContainer} data-testid="app-shell-skeleton">
      <aside className={skeletonStyles.sidebar}>
        <div className={skeletonStyles.logoContainer}>
          <Skeleton width={128} height={36} />
        </div>
        <nav className={skeletonStyles.nav}>
          {[1, 2, 3, 4, 5].map((i) => (
            <div key={i} className={skeletonStyles.navItem}>
              <Skeleton variant="circular" width={20} height={20} />
              <Skeleton height={20} style={{ flex: 1 }} />
            </div>
          ))}
        </nav>
        <div className={skeletonStyles.footer}>
          <Skeleton width="100%" height={40} />
          <div className={skeletonStyles.userMenu}>
            <Skeleton variant="circular" width={32} height={32} />
            <Skeleton width={100} height={20} />
          </div>
        </div>
      </aside>

      <main className={skeletonStyles.main}>
        <header className={skeletonStyles.header}>
          <Skeleton width={120} height={32} />
          <Skeleton width={150} height={24} />
        </header>
        <div className={skeletonStyles.content}>
          <div className={skeletonStyles.contentRow}>
            <Skeleton width="60%" height={40} />
            <div className={skeletonStyles.contentGrid}>
              <Skeleton height={200} />
              <Skeleton height={200} />
              <Skeleton height={200} />
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
